import Phaser from 'phaser';
import PopOutButton from './PopOutButton';

export default class SelectButtonGroup extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,btnNames, btnTxts) {
    super(scene);

    this.buttons = [];
    let i = 0;
    while (i < btnNames.length) {
      const btn = new PopOutButton(this.scene, null, btnTxts[i], btnNames[i]);
      this.add(btn);
      this.buttons.push(btn);
      i++;
    }
  }

  showButtons () {
    const spacing = this.scene.scale.width / (this.buttons.length + 1);

    const startX = spacing;
    for (let i = 0; i < this.buttons.length; i++) {
      const btn = this.buttons[i];
      btn.x = startX + (i * spacing);
      btn.y = this.scene.scale.height / 2;
      btn.popIn();
      btn.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.selectBtn(btn));
    }
  }

  /**
   * @param {PopOutButton} sender
   */
  selectBtn (sender) {
    for (let i = 0; i < this.buttons.length; i++) {
      this.buttons[i].popOut();
    }

    this.emit('BTN_SELECT', { _info: sender.btnValue });
  }

  hideButtons () {
    for (let i = 0; i < this.buttons.length; i++) {
      const btn = this.buttons[i];
      this.buttons[i].popOut();
      btn.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN);
    }
  }
}